/*
  Delay home banner video file for 3 seconds
*/

export function delayHomeBannerVideoFile() {
  setTimeout(function() {
    $('#home-banner-video').attr('src',$('#hidden-video-file').text());
  }, 3000);
}

export function delayFooterVideoFile() {
  setTimeout(function() {
    $('#footer-video').attr('src',$('#hidden-video-file-footer').text());
  }, 3000);
}